/**
 * ============================================================================
 * Material 模块 - 枚举定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义模块相关的所有枚举类型
 * - 包含：MaterialType, MaterialStatus, MaterialUnitType, MaterialUnitCode 等
 * 
 * 📖 对应后端：
 * - Model: backend/app/Modules/Material/Models/Material.php (常量定义)
 * - Model: backend/app/Modules/Material/Models/MaterialUnit.php (常量定义)
 * 
 * ⚠️ 注意事项：
 * - 枚举值必须与后端完全一致
 * - 每个枚举值必须添加中文注释
 * - 使用 TypeScript enum 而不是 type
 * 
 * 🔄 更新时机：
 * - 后端新增枚举值时
 * - 后端修改枚举值时
 * - 业务新增状态/类型时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/app/Modules/Material/Models/Material.php
 * 2. 找到所有 const TYPE_*, const STATUS_* 等常量定义
 * 3. 读取 backend/app/Modules/Material/Models/MaterialUnit.php
 * 4. 检查枚举值、名称是否与后端一致
 * 5. 检查是否有遗漏或多余的枚举值
 * 
 * @module types/material/enums
 * @generated Manual (AI-assisted)
 * @last-updated 2025-10-30
 * ============================================================================
 */

/**
 * 物料类型枚举
 * 
 * 对应后端: Material::TYPE_*
 */
export enum MaterialType {
  /** 原材料 */
  RAW = 'RAW',
  
  /** 半成品 */
  SEMI = 'SEMI',
  
  /** 成品 */
  PRODUCT = 'PRODUCT',
  
  /** 辅料 (Auxiliary Material) */
  AUX = 'AUX',
}

/**
 * 物料状态枚举
 * 
 * 对应后端: Material::STATUS_*
 */
export enum MaterialStatus {
  /** 启用 */
  ACTIVE = 1,
  
  /** 停用 */
  INACTIVE = 0,
}

/**
 * 物料单位类型枚举
 * 
 * 对应后端: MaterialUnit::TYPE_*
 */
export enum MaterialUnitType {
  /** 基本单位 */
  BASE = 'BASE',
  
  /** 采购单位 */
  PURCHASE = 'PURCHASE',
  
  /** 生产单位 */
  PRODUCTION = 'PRODUCTION',
}

/**
 * 物料单位代码枚举（常用单位）
 * 
 * 对应后端: MaterialUnit::UNIT_*
 */
export enum MaterialUnitCode {
  /** 个 */
  PCS = 'PCS',
  
  /** 箱 */
  BOX = 'BOX',
  
  /** 盘 */
  REEL = 'REEL',
  
  /** 千克 */
  KG = 'KG',
  
  /** 吨 */
  T = 'T',
  
  /** 克 */
  G = 'G',
  
  /** 升 */
  L = 'L',
  
  /** 毫升 */
  ML = 'ML',
  
  /** 米 */
  M = 'M',
  
  /** 平方米 */
  M2 = 'M2',
  
  /** 立方米 */
  M3 = 'M3',
}

/**
 * 物料单位状态枚举
 * 
 * 对应后端: MaterialUnit::STATUS_*
 */
export enum MaterialUnitStatus {
  /** 启用 */
  ACTIVE = 1,
  
  /** 停用 */
  INACTIVE = 0,
}

